export type TypeFilter = "all" | "company" | "independent";

export const CLIENTS_PER_PAGE = 12;
export const SESSIONS_PER_PAGE = 8;
